<template>
  <div class="userinfo-widget">
    <div class="user-avatar">
      <app-icon  class="app-icon" name="person"></app-icon>
    </div>
    <div class="user-details">
      <div class="user-phone">{{ phone }}</div>
      <div class="user-id">ID: {{ userId }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfoWidget',
  data() {
    return {
      phone: '****',
      userId: '---'
    }
  },
  created() {
    this.$ajax.get('api/v1/users/me').then(res => {
      if (res.data) {
        this.phone = res.data.phone || '****'
        this.userId = res.data.id || '---'
      }
    })
  }
}
</script>

<style scoped>
.userinfo-widget {
  display: flex;
  align-items: center;
  gap: 14px;
}

.user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
}

.user-avatar .app-icon {
  font-size: 24px;
  color: #ffffff;
}

.user-details {
  flex: 1;
}

.user-phone {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
}

.user-id {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/User2/widgets/UserInfoWidget.vue